<template>
  <div class="pda-default" v-if="surveyData">
    <div class="mdc-card mdc-elevation--z3 pda-default">
      <div class="t-subtitle2">
        {{ $t("226") }}
        <!-- 설문 안내 -->
      </div>
      <div class="t-body3 mgt-16 t-color-bodyGrayA">
        {{ surveyData.summary }}
      </div>
    </div>

    <div class="mdc-card mdc-elevation--z3 mgt-16 pdb-20">
      <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
        {{ $t("227") }}
        <!-- 기간 정보 -->
      </div>
      <div>
        <div class="d-flex flex-row pdt-24 mgl-8 mgr-8 t-body3">
          <div class="pdl-8 pdr-8 flex-grow-1 t-color-bodyGrayA">
            {{ $t("697") }}
            <!-- 설문 응답 기간 -->
          </div>
          <div class="pdl-8 pdr-8">
            {{ $moment(surveyData.application.start).format("L") }}
            ~
            {{ $moment(surveyData.application.end).format("L") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["surveyData"],
};
</script>

<style>
</style>